import { useTranslation } from 'react-i18next';
import { usePortalName } from './usePortalName';

export const useCommonTranslation = (): Function => {
  const portalName = usePortalName();
  const { t } = useTranslation(portalName || 'common');
  return (
    key: string | TemplateStringsArray | (string | TemplateStringsArray)[],
    params?: any,
  ) => t(key, params) || '';
};
